import React, { Fragment } from 'react';
import { H1, Text } from 'base-components';
import { Trans } from 'lingui-react';
import { curry, get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import { Row, Column } from 'styled-components-reactive-grid';

import Panel from 'blocks/Panel';

import Loading from 'components/Loading';

import ScrollColumn from 'elements/ScrollColumn';

import DealersTable from '../DealersTable';

import manageableDealersQuery from './manageableDealersQuery';

function Dealers({ dealers, dealersLoading }) {
  if (!dealersLoading && dealers.length === 1) {
    return <Redirect to={`/tech-admin/dealers/${dealers[0].id}`} />;
  }

  return (
    <Fragment>
      <Row>
        <Column modifiers={['col', 'padScale_0']}>
          <Panel modifiers={['padScale_5']}>
            <Row>
              <Column modifiers={['col', 'padScaleX_4', 'padScaleY_2']}>
                <H1 modifiers={['fontWeightLight']}>
                  {dealersLoading || isEmpty(dealers) ? (
                    <Trans>Loading...</Trans>
                  ) : (
                    <Trans>My Stores</Trans>
                  )}
                </H1>
                <Text>
                  <Trans>
                    Select one of the{' '}
                    <Text modifiers={['fontWeightBold']}>
                      {dealers.length} stores
                    </Text>{' '}
                    to view and edit details
                  </Trans>
                </Text>
              </Column>
            </Row>
          </Panel>
        </Column>
      </Row>
      <Row modifiers={['flex_1']}>
        {dealersLoading ? (
          <Loading />
        ) : (
          <ScrollColumn modifiers={['col', 'padScale_0']}>
            <Panel
              modifiers={['height_100', 'flex_column', 'padScale_0']}
              style={{ overflowY: 'scroll' }}
            >
              <Row modifiers={['flex_1']}>
                <DealersTable dealers={dealers} />
              </Row>
            </Panel>
          </ScrollColumn>
        )}
      </Row>
    </Fragment>
  );
}

Dealers.propTypes = {
  dealers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  dealersLoading: PropTypes.bool.isRequired,
};

const buildQueryChild = curry((componentProps, queryProps) => {
  const { loading: dealersLoading } = queryProps;
  const dealers = get(queryProps, ['data', 'manageableDealers', 'dealers'], []);
  return (
    <Dealers
      {...componentProps}
      dealers={dealers}
      dealersLoading={dealersLoading}
    />
  );
});

function DealersWithQuery(componentProps) {
  return (
    <Query query={manageableDealersQuery}>
      {buildQueryChild(componentProps)}
    </Query>
  );
}

export default DealersWithQuery;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/Dealers/index.js